import { Typography } from '@mesa-labs/mesa-ui';
import styled from 'styled-components';

export const HeaderContainer = styled.div<{ marginBottom?: number }>`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: ${(props) => props.theme.breakpoints.Mobile}) {
    margin-bottom: ${(props) => props.marginBottom ?? 20}px;
  }
`;

export const AccountHeaderContainer = styled(HeaderContainer)`
  align-items: center;
  border-bottom: 1px solid #ECF0F4;
  flex-direction: row;
  margin-bottom: 24px;
  padding-bottom: 24px;

  @media (min-width: ${(props) => props.theme.breakpoints.Tablet}) {
    margin-bottom: 32px;
  }
`;

export const TopHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  width: fit-content;
`;

export const HeaderLabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 8px;
`;

export const HeaderLabel = styled.p`
  color: #525866;
  font-family: ${(props) => props.theme.fonts.inter};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.084px;
`;

export const Header = styled.div`
  color: #0E121B;
  font-family: ${(props) => props.theme.fonts.grotesk};
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: -0.64px; 
  line-height: 125%;
  margin-bottom: 4px;

  @media (min-width: ${(props) => props.theme.breakpoints.Mobile}) {
    font-size: 32px;
  }
`;

export const SubHeader = styled.div<{ marginBottom?: string }>`
  color: rgba(29, 29, 29, 0.7);
  font-size: 14px;
  line-height: 24px;
  margin-bottom: ${(props) => props.marginBottom || '20px'};
`;

export const SectionHeaderContainer = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.colors.Gray200};
  cursor: pointer;
  margin-bottom: 24px;
  padding-bottom: 20px;
`;

export const SectionHeader = styled(Typography.BodyLarge)`
  color: ${(props) => props.theme.colors.Black};
  font-weight: 500;
  margin-bottom: 4px;
`;

export const SectionSubHeader = styled.div`
  color: #667085;
  font-size: 14px;
  line-height: 20px;
`;
